import React from "react";
import { Card, CardContent, Box } from "@mui/material";
import bestOffers from "../assets/bestOffers";
import { useClientContext } from "../context/ClientContext";

function NextBestOffers() {
  const { clientGroup } = useClientContext();

  const bestOffer = bestOffers.filter(
    (offer) => offer.group_name === clientGroup
  )[0];

  return (
    <div style={{ height: "40vh", overflowY: "auto" }} className="p-2">
      <Box>
        {bestOffer?.recommended.map((item, index) => (
          <Box key={index}>
            <Card className="mb-4 shadow-md text-xs text-gray-600">
              <CardContent>
                <Box className="mt-4">
                  <div className="text-sm font-bold my-2">{item.product}</div>

                  <div>
                    {item.features?.reason_code ? (
                      <p className="py-2">
                        <span className="font-bold ">Reason Code : </span>
                        {item.features?.reason_code}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>

                  <p>{item.features?.desc ?? item.features?.desc}</p>

                  {item.features.lists.map((list, key) => (
                    <div key={key} className="py-2">
                      <p className="py-1 font-bold">{list.label}:</p>
                      <ul className="list-disc ml-6 ">
                        {list.items.map((item, key) => (
                          <li key={key} className="">
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>
    </div>
  );
}

export default NextBestOffers;
